import React from 'react';
import { useTranslation } from 'next-i18next';
import NoImageIcon from 'components/icon/noimage-icon';
import NoImageExpIcon from 'components/icon/noimageexp-icon';
import styles from './style.module.scss';
import { buildClassName } from 'utils/build-class-name';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';

interface Props {
  isRecent?: boolean;
  isExpTheme?: boolean;
  className?: string;
}

export default function NoImage({ isRecent, isExpTheme, className }: Props) {
  const { t } = useTranslation(Namespaces.COMMON);

  return <div className={buildClassName(styles.component, isExpTheme && styles.round, className)}>
    {isExpTheme ? <NoImageExpIcon /> : <NoImageIcon />}
    {
      isRecent ? 
        <p dangerouslySetInnerHTML={{ 
          __html: t(LOCALE_COMMON_PATHS.NO_IMAGE_NEW_LISTING_PHOTOS_COMING_SOON, {
            defaultValue: 'This listing is new&#10024;<br/>Photos coming soon',
          }),
        }} /> :
        <p>{t(LOCALE_COMMON_PATHS.NO_IMAGE_PHOTOS_COMING_SOON, {
          defaultValue: 'Photos Coming Soon',
        })}</p>
    }
  </div>;
}
